export default {
  /**
   * This function is called while looping through dutyActivities to create a list of duty activities whose activities
   * might merge several items. Each item can have child objects within the children attribute.
   *
   * shouldMergeDutyActivity must check what happens with the currentDutyActivity. However the function does not
   * manipulate data but needs to return an advice what should be done (described in return)
   *
   * @param {Object} MeinDienst module configuration object
   * @param {Object} accumulator The duty activity which may accumulate other duty activities
   * @param {Object} currentDutyActivity The current duty activity when looping through all activities
   * @param {Array} dutyActivities all duty activities
   * @param {Number} currentIndex the current index when looping through the duty activities
   * @returns string one of the following
   *                 new: that is the current item is used right away
   *                 mergeToAccumulator: the next two items are merged with the current item
   */
  shouldMergeDutyActivity: ({ moduleConfig, accumulator, currentDutyActivity, dutyActivities, currentIndex }) => {
    let i = currentIndex;
    if (!accumulator) {
      return 'mergeToAccumulator';
    } else {
      if (
        accumulator.course === currentDutyActivity.course ||
        (!accumulator.course &&
          !currentDutyActivity.course &&
          !accumulator.line &&
          !currentDutyActivity.line &&
          !accumulator.blockcode &&
          !currentDutyActivity.blockcode &&
          accumulator._dutyActivityGroup === currentDutyActivity._dutyActivityGroup)
      ) {
        // as long as these conditions are met, the duty activity can be collapsed and thus merged to the accumulator
        // object which collects collapsible items within the children attribute
        return 'mergeToAccumulator';
      }

      return 'new'; // instruction to create a new accumulator, that is a new outer item (collapsible card) is created
    }
  },
  /**
     * Returns the last duty activity in the sorted list of duty activities.
     * Defaults to return the last activity within the array of activities

     * @param {Object} MeinDienst module configuration object
     * @param {*} dutyActivities
     * @returns the last relevant duty activity
     */
  getLastActivity: ({ moduleConfig, dutyActivities }) => {
    return dutyActivities[dutyActivities.length - 1];
  },
};
